import { Link } from "react-router-dom";
import SeriesNavigation from "../../components/SeriesNavigation";
import { leadershipMembers } from "../../data/navigationData";
import SEO from "../../components/SEO";

export default function DavidMazzo() {
  const davidMazzoSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "David Mazzo",
    "jobTitle": "Independent Director",
    "affiliation": {
      "@type": "Organization",
      "name": "Thrombio"
    },
    "url": "https://www.thrombio.com.au/leadership/david-mazzo"
  };

  return (
    <div className="boardOfDirectorsBg" style={{"--bg-opacity": "0.2"}}>
      <SEO
        title="David Mazzo - Independent Director"
        description="Dr. David J. Mazzo is a highly accomplished and experienced pharmaceutical executive and public and private company board member with almost 45 years of global pharmaceutical experience."
        keywords={['David Mazzo', 'Independent Director', 'Pharmaceutical Executive', 'Drug Development']}
        ogImage="/davidMazzo.webp"
        schema={davidMazzoSchema}
      />

      <div className="page-width px-20 pt-[18px] pb-8">
        <nav className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2 font-sans text-[2rem] font-normal leading-[3.8rem]" aria-label="Breadcrumb">
          <Link to="/leadership/board-of-directors" className="text-white hover:text-primary-red transition-colors">
            Board of Directors
          </Link>
          <div className="flex items-center gap-2">
            <span className="text-white">/</span>
            <span className="text-[#5C95A4]">David Mazzo</span>
          </div>
        </nav>

        <div className="flex flex-col gap-4 md:gap-16 pt-24">
          <div className="text-[3.8rem] md:text-[4.8rem] font-bold leading-[4.2rem] md:leading-[5.2rem] tracking-[.19rem] drop-shadow-[0_4px_8.9px_#000]">
            David Mazzo
          </div>
          <div className="text-left justify-start text-[#e0ffff] text-[2.9rem] font-medium leading-[3.6rem] tracking-[.096rem] [text-shadow:_2px_4px_5px_rgb(0_0_0_/_1.00)]">
            Independent Director
          </div>
        </div>
      </div>

      <div className="pt-[130px] xl:pt-[90px] xl:pb-[80px] page-width">
        <div className="w-full">
          <div className="grid lg:grid-cols-12 gap-16 items-start">
            <div className="lg:col-span-3">
              <img 
                src="/davidMazzo.webp" 
                alt="David Mazzo, Independent Director: Expert in Pharmaceutical and Medical Device Management" 
                className="w-full" 
                width={650} 
                height={650} 
              />
            </div>
            
            <div className="lg:col-span-8 flex flex-col">
              <div className="text-[2rem] leading-[3.6rem] tracking-[0.8px] font-normal text-left text-white">
                Dr. David J. Mazzo is a highly accomplished and experienced pharmaceutical executive and public and private company board member who has held executive positions in both big and small Pharma globally.  He is recognized for his exceptional strategic, scientific, and regulatory expertise, upon which he has amassed a track record of almost 45 years of successful global pharmaceutical product development, registration, and launch.
              </div>
            </div>
          </div>
        </div>
      </div>
      <SeriesNavigation 
        items={leadershipMembers} 
        currentSlug="david-mazzo" 
        basePath="/leadership" 
      />
    </div>
  );
}